import {
  AblyGoodsCardActionType,
  AblyGoodsCardChipType,
} from '../../../../api/types';
import {
  isPrimaryCard,
  type CardEntity,
  type GoodsCardEntity,
  type PrimaryCardEntity,
} from './types';

import type { GoodsData } from '@banhala/ui-kit';

export type CardRenderItem = (GoodsData & GoodsCardEntity) | PrimaryCardEntity;

export const cardRenderItemGenerator = (entity: CardEntity[]): CardRenderItem[] => {
  return entity.flatMap((item): CardRenderItem[] => {
    if (isPrimaryCard(item)) {
      return [item];
    }

    const { item: goods, render, logging, type } = item;
    if (!render) {
      return [];
    }

    return [{
      type,
      item: goods,
      logging,
      render,
      sno: goods.sno,
      deliveryType: goods.delivery_type,
      thumbnail: {
        src: goods.image,
        freesSrc: goods.image,
        closedReason: render.data.closed_reason ?? undefined,
        hideLike: !render.data.actions?.includes(AblyGoodsCardActionType.Like),
        badges: (render.data.image_badge_list ?? []).map(badge => ({
          uri: badge.image_url,
          width: badge.image_width,
          height: badge.image_height,
        })),
      },
      contents: {
        price: {
          price: render.data.price,
          discount: render.data.discount_rate ?? '',
        },
        topNudging: render.data.top_nudging_text ?? undefined,
        priceDescription: render.data.price_description
          ? { name: render.data.price_description.text }
          : undefined,
        name: {
          goodsName: goods.name,
          marketName: render.data.store_text ?? goods.market_name ?? null,
          nameLineCount: render.data.name_lines,
          showBrand: false,
        },
        imageAd: render.data.has_ad_badge,
        nudge: render.data.nudging_text ?? undefined,
        chips: (render.data.chips ?? []).map(chip => {
          if (chip.type === AblyGoodsCardChipType.DittoText) {
            return {
              type: chip.type,
              name: chip.name,
              customTag: chip.meta
                ? {
                    bgColor: chip.meta.bg_color,
                    borderColor: chip.meta.border_color,
                    borderWidth: chip.meta.border_width ?? 0,
                    borderRadius: chip.meta.rounded_corner_radius ?? 0,
                    textColor: chip.meta.text_color,
                    textType: chip.meta.text_style,
                  }
                : undefined,
            };
          }
          return {
            type: chip.type,
            name: chip.name ?? '',
          };
        }),
      },
    }];
  });
};
